import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

const Address = () => (
	<Box sx={{ marginTop: '2rem' }}>
		<Box>
			<Typography variant="h4" gutterBottom color="primary">
				Contact us to plan your perfect feast!
			</Typography>

			<Typography display="flex" alignItems="center" className="mb-2">
				<LocationOnOutlinedIcon color="primary" sx={{ marginRight: 1 }} />
				<Typography color="secondary" variant="subtitle2" fontWeight={600}>
					Avadi / Thiruninravur / Redhills
				</Typography>
			</Typography>

			<Typography display="flex" alignItems="center" className="mb-2">
				<EmailOutlinedIcon color="primary" sx={{ marginRight: 1 }} />
				<Typography color="secondary" variant="subtitle2" fontWeight={600}>
					<Link
						href="mailto:chakaravarthycatering@gmail.com"
						rel="noopener"
						underline="none"
						color="secondary"
					>
						chakaravarthycatering@gmail.com
					</Link>
				</Typography>
			</Typography>

			<Typography display="flex" alignItems="center" className="mb-2" fontWeight={600}>
				<CallOutlinedIcon color="primary" sx={{ marginRight: 1 }} />
				<Typography
					textAlign="start"
					color="secondary"
					variant="subtitle2"
					fontWeight={600}
				>
					<Link href="tel:9500066066" rel="noopener" underline="none" color="secondary">
						(+91) 9500066066
					</Link>
					<span> / </span>
					<Link href="tel:9884433383" rel="noopener" underline="none" color="secondary">
						9884433383
					</Link>
				</Typography>
			</Typography>

			<Box
				sx={{
					mt: 2,
					width: '100%',
					height: { xs: '100%', sm: '100%', md: '100%' },
					minHeight: { xs: '100%', sm: '100%', md: '260px' },
					maxHeight: { xs: '100%', sm: '100%', md: '700px' },
					position: 'relative',
					padding: { xs: '0px', sm: '0px' },
				}}
				className="pe-4"
			>
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.78334053961!2d80.1019651!3d13.1129075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526279099dc235%3A0x6e0787993cc11764!2sSri%20Chakravarthy%20Catering%20centre!5e0!3m2!1sen!2sin!4v1744091083059!5m2!1sen!2sin"
					width="100%"
					allowFullScreen
					// height={'inherit'}
					height={'100%'}
					style={{ minHeight: 'inherit', maxHeight: 'inherit', borderRadius: '10px' }}
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
				/>
			</Box>
		</Box>
	</Box>
);

export default Address;
